var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"portal",rawName:"v-portal"}]},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }